var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9083 2.82373H24.261L7.06055 22.0783C8.21796 58.2323 31.4413 76.8185 42.9083 81.5923V2.82373Z",
    fill: "url(#paint0_linear_604_32505)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.067 12.3719H29.6878L17.3467 26.2197C18.1771 52.2213 34.8396 65.5884 43.067 69.0217V12.3719Z",
    fill: "url(#paint1_linear_604_32505)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9052 2.82373H61.5524L78.7529 22.0783C77.5955 58.2323 54.3722 76.8185 42.9052 81.5923V2.82373Z",
    fill: "url(#paint2_linear_604_32505)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7416 12.3719H56.1208L68.4619 26.2197C67.6315 52.2213 50.969 65.5884 42.7416 69.0217V12.3719Z",
    fill: "url(#paint3_linear_604_32505)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 34.8,
    y: -5.11743,
    width: 51.73,
    height: 94.6509
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3.97px)",
      clipPath: "url(#bgblur_0_604_32505_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 7.94116,
    d: "M42.7411 2.82373H61.3884L78.5889 22.0783C77.4315 58.2323 54.2081 76.8185 42.7411 81.5923V2.82373Z",
    fill: "url(#paint4_linear_604_32505)",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_604_32505_clip_path",
    transform: "translate(-34.8 5.11743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7411 2.82373H61.3884L78.5889 22.0783C77.4315 58.2323 54.2081 76.8185 42.7411 81.5923V2.82373Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_604_32505",
    x1: 7.06055,
    y1: 8.02927,
    x2: 42.3383,
    y2: 76.6797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.217548,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E6E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_604_32505",
    x1: 17.3467,
    y1: 16.1157,
    x2: 42.7531,
    y2: 65.4396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.217548,
    stopColor: "#FF6C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9123"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_604_32505",
    x1: 78.7529,
    y1: 8.02927,
    x2: 43.4752,
    y2: 76.6797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.217548,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E6E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_604_32505",
    x1: 68.4619,
    y1: 16.1157,
    x2: 43.0555,
    y2: 65.4396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.217548,
    stopColor: "#FF6C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9123"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_604_32505",
    x1: 78.5889,
    y1: 8.02927,
    x2: 43.3111,
    y2: 76.6797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.217548,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E6E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.5d51ea49295b70b3c948b71bf58b7116.svg";
export { ForwardRef as ReactComponent };